import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { useAuthToken } from "./useAuthToken"

export type ResortVisitSummaryRow = {
  resortId: number
  resortUid: string
  name: string
  userCount: number
  liftCount: number
}

type ResortVisitSummaryResponse = {
  resorts: ResortVisitSummaryRow[]
}

export function useResortVisitSummary() {
  const token = useAuthToken()

  return useQuery({
    queryKey: ["resort-visits"],
    queryFn: async () => {
      return apiFetch<ResortVisitSummaryResponse>("/admin/resort-visits", {
        token,
        method: "GET",
      })
    },
  })
}
